export default __webpack_public_path__ + "static/media/allocation-1.a4e1c6f8.webp";